export default __webpack_public_path__ + "static/media/yt.9fae5548.svg";